export const NAV_LINKS = [
  { label: 'Home', href: '/', isRoute: true },
  { label: 'About', href: '/#about' },
  { label: 'Case Studies', href: '/#case-studies' },
  { label: 'Projects', href: '/#projects' },
  { label: 'Contact', href: '#contact' },
];

export const CONTACT = {
  email: 'dj@derekjohnston.com',
  linkedin: 'https://www.linkedin.com/in/derek-johnston-80549514',
};
